module.exports = require("@swa-ui/placements/src/Banner/BannerLayout3.module.scss");